import { Global } from '../../global';
import { DariCalendarService } from '../../../services/DariCalendar';
import { Component, OnInit } from '@angular/core';
import { ReportService } from '../../../services/Acc_ReportService';
import { UtilityService } from '../../../services/Acc_Utility.service';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import * as moment from 'jalali-moment';

@Component({
  selector: 'app-trail-balance',
  templateUrl: './trail-balance.component.html',
  styleUrls: ['./trail-balance.component.css']
})
export class TrailBalanceComponent implements OnInit {
  ArrLabels: any;
  labels: any = {};
  AsOfDate: Date = new Date();
  AsOfDate_DariDate: string;

  gl_childs:any;

  constructor(
    private ReportService: ReportService,
    private DariCalendar: DariCalendarService,
    private UtilityService: UtilityService,
    private global:Global,
    private dateConverter: DatePipe
  ) { }

  ngOnInit() {
    var _date = new Date();
    this.getBranchId();
    this.getGlChilds(this.dateConverter.transform(_date,'yyyy-MM-dd'));
    this.getLabels();
    this.AsOfDate_DariDate = moment(_date).format('jYYYY-jMM-jDD');
  }

  isBranchId: number = -1;
  getBranchId() {
     
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/discount")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch)
        this.isBranchId = 1;
      else if (dataAccessUrl.isWestBranch)
        this.isBranchId = 2;
      else
        this.isBranchId = 0;
    }
  }

  getGlChilds(AsOfDate: string)
  {
    this.ReportService.TrialBalance(AsOfDate,this.isBranchId)
      .subscribe(response => {
        if (response) {
            this.gl_childs = response;
            console.log(response);
        }
    },
    error => console.log("error --> " + error))

  }

  AsOfDateChanged(type: string, event: MatDatepickerInputEvent<moment.Moment>) {
    var _pdate = moment(event.value).format('jYYYY-jMM-jDD');
    var _date = moment.from(_pdate,'fa').format('YYYY-MM-DD');
    this.getGlChilds(_date.toString());
    this.AsOfDate_DariDate = _pdate;
  }

  getLabels(){
    this.UtilityService.getLabels('trial-balance',this.global.lang)
      .subscribe(response => {
          if(response){
              this.ArrLabels = response;
              console.log(response);
              this.setLabels();
          }
      },
      error => console.log(error))
    }

  setLabels(){
    this.labels['trial-balance-Title'] = this.ArrLabels.find( (o:any) => o.key === 'trial-balance-Title').value;
    this.labels['MasterAccountID'] = this.ArrLabels.find( (o:any) => o.key === 'MasterAccountID').value;
    this.labels['MasterAccountDesc'] = this.ArrLabels.find( (o:any) => o.key === 'MasterAccountDesc').value;
    this.labels['MasterAccountDesc_en'] = this.ArrLabels.find( (o:any) => o.key === 'MasterAccountDesc_en').value;
    this.labels['AccountID'] = this.ArrLabels.find( (o:any) => o.key === 'AccountID').value;
    this.labels['AccountDesc'] = this.ArrLabels.find( (o:any) => o.key === 'AccountDesc').value;
    this.labels['AccountDesc_en'] = this.ArrLabels.find( (o:any) => o.key === 'AccountDesc_en').value;
    this.labels['AccountBalanceDR'] = this.ArrLabels.find( (o:any) => o.key === 'AccountBalanceDR').value;
    this.labels['AccountBalanceCR'] = this.ArrLabels.find( (o:any) => o.key === 'AccountBalanceCR').value;
    this.labels['AsOfDate'] = this.ArrLabels.find( (o:any) => o.key === 'AsOfDate').value;
  }


}



// WEBPACK FOOTER //
// ./src/app/components/reports/trail-balance/trail-balance.component.ts